// extracted by mini-css-extract-plugin
export default {"about-me":"About_about-me__9M9Ti","animate":"About_animate__QDDIA","content":"About_content__klvMA","second-about":"About_second-about__M4wuz","clipPath":"About_clipPath__xbj2b"};